// extracted by mini-css-extract-plugin
export default {"root":"integrationContextTabs_root__vsDGx","tab":"integrationContextTabs_tab__zFy-Q","tabActive":"integrationContextTabs_tabActive__Tc5y-"};